import React, { useState, useEffect } from 'react';
import { Input, Label } from '../../Shared';
import { useAppContext } from '../../context/AppContext';
import axios from 'axios';
import States from '../../components/States';

const MailOwner = ({ company, onClose, owner,setPermit,reset,setReset,editOwnerItemId}) => {
  const { user, axiUrl } = useAppContext();



  console.log(owner);
  
  const [formData, setFormData] = useState({
    id:null,
    template:"",
    companyName: '',
  address: '',
  address2:'',
  city: '',
  state:'FL',
  zip: '',
  crid:'',
  mid:'',  
  nonprofitnumber: '',
  anywhere:'',
    company:company
  });
  const [filteredBmeus, setFilteredBmeus] = useState();

  useEffect(() => {
    if (owner) {
      setFormData({
        id:owner._id,
           template: owner.template,
           companyName: owner.companyName,
  address: owner.address,
  address2:  owner.address2,
  city: owner.city,
  state: owner.state,
  zip: owner.zip,
  crid: owner.crid,
  mid: owner.mid,  
  nonprofitnumber: owner.nonprofitnumber,
  anywhere: owner.anywhere,
    company:company
      });
    }
  }, [owner]);

   


 const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
   
    const url = editOwnerItemId ? `${axiUrl}/permits/updatemailowner` : `${axiUrl}/permits/addmailowner`;
        const payload = editOwnerItemId ? { ...formData, id: editOwnerItemId } : formData;
console.log('paylod',payload)

   const res = await axios.post(url, payload)
      .then(res => {console.log(res.data)
       setReset(!reset);
    onClose();
  })
       
  };


  console.log(formData)
  return (
    <div className='w-full'>
      <form onSubmit={handleSubmit}>
        <div className='flex w-full gap-[20px]'>
          <div className='flex-3 relative'>
            <div className='w-full'>
              <Label>Mail Owner Name</Label>
            </div>
            <div>
              <Input 
                type="text" 
                name="template"
                value={formData.template}
                onChange={handleChange}
                required
              />
            </div>
            <div className='relative p-3 border border-gray-400 mt-3 pb-6'>
              <h2 className="absolute -top-[13px] bg-white px-[3px]">Mail Owner Information</h2>
              <div className='mb-[6px]'>
                <Label fontSize="12px" mb="2px">Company Name</Label>
                <Input 
                  width="100%" 
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='mb-[6px]'>
                <Label fontSize="12px" mb="2px">Address 1</Label>
                <Input 
                  width="100%" 
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='mb-[6px]'>
                <Label fontSize="12px" mb="2px">Address 2</Label>
                <Input 
                  width="100%" 
                  name="address2"
                  value={formData.address2}
                  onChange={handleChange}
                />
              </div>
              <div className='flex gap-[5px]'>
                <div className='mb-[6px] flex-2 gap-[5px]'>
                  <Label fontSize="12px" mb="2px">City</Label>
                  <Input 
                    width="100%" 
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className='mb-[6px] flex-1'>
                  <Label fontSize="12px" mb="2px">State</Label>
                  <States setFormData={setFormData} formData={formData} />
                </div>
                <div className='mb-[6px] flex-1'>
                  <Label fontSize="12px" mb="2px">Zip</Label>
                  <Input 
                    width="100%" 
                    name="zip"
                    value={formData.zip}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>
          </div>
   
        </div>
        <div>
          <div className='relative p-3 border border-gray-400 pb-6 '>
            <h2 className="absolute -top-[13px] bg-white px-[3px]">Postal Information</h2>
            <div className='flex gap-[10px] justify-center'>
              <div className='mb-[6px] mt-[11px] justify-center '>
                <Label fontSize="12px" mb="2px">Mail Owner CRID</Label>
                <Input 
                  width="100%" 
                  name="crid"
                  value={formData.crid}
                  onChange={handleChange}
                  maxLength="10"
                  pattern="[0-9\s]*"
                  required
                />
              </div>
              <div className='mb-[6px] mt-[11px] '>
                <Label fontSize="12px" mb="2px" width="100%">
                 Mail Owner MID
                </Label>
                <Input 
                  width="100%" 
                  name="mid"
                  value={formData.mid}
                  onChange={handleChange}
                  //required={formData.permitType === 'Stamp'}
                />
              </div>
            </div>
   <div className='flex gap-[10px] justify-center '>
              <div className='mb-[6px] mt-[18px] '>
                <Label fontSize="12px" mb="2px">Nonprofit Authorization Number</Label>
                <Input 
                  width="100%" 
                  name="nonprofitnumber"
                  value={formData.nonprofitnumber}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="[0-9\s]*"
                  
                />
              </div>
              <div className='b-[6px] mt-[18px] '>
                <Label fontSize="12px" mb="2px" width="100%">
               Mail Anywhere Account Number
                </Label>
                <Input 
                  width="100%" 
                  name="anywhere"
                  value={formData.anywhere}
                  onChange={handleChange}
                  
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-2 mt-[10px]">
          <button
            type="button"
            onClick={onClose}
            className="text-[12px] px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="text-[12px] px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            {editOwnerItemId ? 'Update Mail Owner' : 'Add Mail Owner'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default MailOwner;

